import React, { useState, useEffect, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import CustomModal from '../../Modal';
import FormGroup from '../../FormGroup';
import Constructor from '../Constructor/Constructor';
import CustomNotify from "../../Notify";
import { I18nContext } from 'utils/I18n/context';

const ConstructorLandings = (props) => {
    const { t } = useContext(I18nContext);
    const constructorMethods = Constructor(props);
    
    const [state, setState] = useState({
        visible: props.visible,
        landing: props.landing,
        goalEntries: props.goalEntries,
        publisherId: props.publisherId,
        offer: props.offer,
        metaParamsmetaParams: {},
        metaParams: {},
        currentLink: {},
        links: props.links,
        selfieLink: '',
        link: '',
        saveLanding: props.saveLanding
    });

    useEffect(() => {
        const isChangeOffer = state.offer !== props.offer;
        const isChangeLanding = state.landing !== props.landing;
        const isChangeLinks = props.links !== props.links;
        let newState = {
            creativeType: 'landing',
            creativeId: props.landing.id,
            visible: props.visible,
            landing: props.landing,
            goalEntries: props.goalEntries,
            links: props.links,
            offer: props.offer,
            goalEntryId: constructorMethods.getFirstGoal()
        };

        if (isChangeOffer || isChangeLanding || isChangeLinks) {
            newState.selfieLink = '';
            newState.metaParams = {};
            newState.currentLink = props.offer.default_link || props.links[0] || {};
        }

        setState(prev => ({ ...prev, ...newState }));
    }, [props]);

    const getLinkParams = useCallback(() => {
        let linkIdParam = '?l=' + state.currentLink.id,
            selfieLink = state.selfieLink;

        return (selfieLink && state.currentLink.selfie_link) ? linkIdParam + '&sl=' + encodeURIComponent(selfieLink) : linkIdParam;
    }, [state.currentLink, state.selfieLink]);

    const getUrl = useCallback((landing) => {
        if(landing.is_external && landing.external_url) {
            return `${landing.external_url}/index.html`;
        }

        return landing.url
    }, []);

    const getCode = useCallback((landing) => {
        let link = getUrl(landing) + '?redirectUrl=' + `${constructorMethods.getResultLink(landing)}`;

        return -1 === link.search('undefined') ? link : '';
    }, [getUrl, constructorMethods]);

    const setParam = useCallback((e) => {
        if (e.target.value.replace(constructorMethods.getAllowChar(), '') !== e.target.value) {
            constructorMethods.onErrorMsg('notAllowCharMsg');
            return false;
        }

        let metaParams = { ...state.metaParams };
        let landing = { ...state.landing };

        metaParams[e.target.placeholder] = e.target.value;
        landing.params[e.target.placeholder] = e.target.value;

        setState(prev => ({
            ...prev,
            metaParams: metaParams,
            landing: landing
        }));
    }, [state, constructorMethods]);

    if (!state.links || !state.links.length) {
        if (state.visible) {
            CustomNotify(t?.constructors?.cantCreateUrlForCreativeNoLinksAvailable || 'Error', 'error');
        }
        return '';
    }

    return (
        <CustomModal
            title={t?.constructors?.createLandingLink || 'Create Landing Link'}
            confirmName={t?.constructors?.copyLandingLink || 'Copy Landing Link'}
            visible={state.visible}
            onClose={props.onClose}
            onConfirm={constructorMethods.onCopyButtonClick}
        >
            {constructorMethods.renderGoalEntries()}

            {constructorMethods.renderOfferLinks()}

            {constructorMethods.renderLandingParams()}

            {constructorMethods.renderParams('landing')}

            {constructorMethods.renderSubMetaParams('landing')}
            {state.currentLink.selfie_link
                ? constructorMethods.renderSelfieLink()
                : null
            }

            <FormGroup
                label={t?.constructors?.resultLandingLink || 'Result Landing Link'}
            >
                <textarea
                    className="form-control"
                    readOnly={true}
                    value={getCode(props.landing)}
                    ref={constructorMethods.resultRef}
                    style={{maxHeight: 100}}
                />
            </FormGroup>
        </CustomModal>
    );
};

ConstructorLandings.propTypes = {
    visible: PropTypes.bool,
    landing: PropTypes.object,
    offer: PropTypes.object,
    goalEntries: PropTypes.array,
    onClose: PropTypes.func
};

ConstructorLandings.defaultProps = {
    visible: false,
    landing: {},
    offer: {},
    goalEntries: [],
    onClose: () => {}
};

export default ConstructorLandings;